import SodColumnsList from './SodColumnsList';

export default SodColumnsList;
